export default {
  title: 'Ícone de site',
  description: 'O ícone deve ter tamanho 32 x 32 pixels, nos formatos PNG ou ICO.',
  observation: 'Após alterar o ícone, você deve publicar o site novamente'
}
